import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const MobileTabBar = () => {
  const location = useLocation();

  const tabItems = [
    { label: 'Home', path: '/homepage', icon: 'Home' },
    { label: 'Feed', path: '/personalised-feed', icon: 'BookOpen' },
    { label: 'Write', path: '/story-editor', icon: 'PenTool' },
    { label: 'Profile', path: '/account-settings', icon: 'User' },
  ];

  const isActive = (path) => location?.pathname === path;

  return (
    <nav className="mobile-tab-bar">
      <div className="mobile-tab-bar-container">
        {tabItems?.map((item) => (
          <Link
            key={item?.path}
            to={item?.path}
            className={`mobile-tab-item ${isActive(item?.path) ? 'active' : ''}`}
          >
            <Icon
              name={item?.icon}
              size={24}
              className="mobile-tab-icon"
            />
            <span className="mobile-tab-label">{item?.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileTabBar;